import {TOGGLE_SORT_MENU} from "../action/UIsortMobile";

const initialState = {
    openSorting: false
};

export default function UIsortMobile(state = initialState, action) {
    switch(action.type) {
        case TOGGLE_SORT_MENU:
            return {
                ...state,
                openSorting: action.payload
            };
        default:
            return state;
    }
}